import React from "react";
import { connect } from "react-redux";
import { ProductWarranteeDetailContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { portalService } from "apiServices";
import { RENDER_UNIT } from "utils/functions/unit";
import {
  CAL_WARRANTY_EXPIRE,
  CHECK_WARRANTY,
  RENDER_WARRANTY_STATUS,
  RENDER_STATUS_PRODUCT_WARRANTY,
} from "utils/functions/productWarranty";
import { RENDER_GENDER_TYPE } from "utils/functions/customer";
import { IMG_PATH } from "utils/constants/imgPath";
import { toast } from "react-toastify";
import moment from "moment";
import momentTZ from "moment-timezone";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { RENDER_CHARACTER_REPLACE_BY_PERMISSION } from "utils/functions/string";
import { MdAdd, MdDelete } from "react-icons/md";
import { ProductWarrantyRegisterContainer } from "./Modals";
import { Buttons, Displays, Forms, Modals } from "components";
import {
  ProductWarrantyStatusWidget,
  ProductWarrantyStoreNameWidget,
} from "widgets";
import { AlertControl } from "components/Modals/Alert";

class ProductWarranteeDetailContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    let [res, resLog] = await Promise.all([
      portalService.GET_PRODUCT_WARRANTEE_DETAIL(this.props.router.params.id),
      portalService.GET_PRODUCT_WARRANTEE_ACTION_LOG(
        `?product_warrantee_ref_id=${this.props.router.params.id}&pagination=false&sort=created_at`,
      ),
    ]);
    if (res && res.status === 200) {
      this.setState({
        data: res.data,
        actionLogs:
          resLog && resLog.status === 200
            ? resLog.data?.docs || resLog.data || []
            : [],
        isLoading: false,
        isBgLoading: false,
      });
    }
  };

  renderActionLabel = (actionType) => {
    switch (String(actionType)) {
      case "1":
        return { label: "อนุมัติ", color: "#2e7d32" };
      case "2":
        return { label: "ปฏิเสธ", color: "#c62828" };
      case "3":
        return { label: "ขยายระยะเวลาประกัน", color: "#1565c0" };
      case "4":
        return { label: "สร้างรายการ", color: "#9e9e9e" };
      case "5":
        return { label: "ลงทะเบียน", color: "#6a1b9a" };
      case "6":
        return { label: "แก้ไขข้อมูล", color: "#ef6c00" };
      case "7":
        return { label: "เพิ่มเข้า Product Set", color: "#00838f" };
      case "8":
        return { label: "นำออกจาก Product Set", color: "#757575" };
      case "9":
        return { label: "ปรับประกันผ่าน Product Set", color: "#1565c0" };
      default:
        return { label: "ไม่ทราบสถานะ", color: "#9e9e9e" };
    }
  };

  renderActorLabel = (actorType) => {
    switch (actorType) {
      case "admin":
        return "โดยแอดมิน";
      case "customer":
        return "โดยลูกค้า";
      case "system":
        return "โดยระบบ";
      default:
        return "";
    }
  };

  handleSubmit = async (values) => {
    const { data } = this.state;



    let checkValue = true;
    // เช็คกรณีเพิ่มระยะเวลาประกันต้องเลือกหน่วยด้วย
    if (values.extension_period || values.extension_unit) {
      if (values.extension_period && values.extension_unit) {
        checkValue = true;
      } else {
        checkValue = false;
      }
    }
    if (checkValue) {
      this.setState({
        isBgLoading: true,
      });
      let params = {
        product_warrantee_id: this.props.router.params.id,
        status: values.status,
      };
      if (values.status === "3") {
        params.approved_warranty_date = values.approved_warranty_date;
      }
      if (values.status === "5") {
        params.rejected_reason = values.rejected_reason;
      }
      if (values.extension_period) {
        params.extension_period = values.extension_period;
      }
      if (values.extension_unit) {
        params.extension_unit = values.extension_unit;
      }
      if (values.slip_img_more && values.slip_img_more.length > 0) {
        params.slip_img = data.slip_img;
        params.slip_img_more = values.slip_img_more.map((e) => e.path);
      }

      if (values.customer_note) {
        params.customer_note = values.customer_note;
      }


          console.log("params", params);

      let res = await portalService.POST_PRODUCT_WARRANTEE_APPROVAL(params);
      if (res && res.status === 200) {
        toast.success("อัพเดตสำเร็จ");
        this.fetchData();
      }
    } else {
      toast.error("กรุณาเลือกใส่ข้อมูลระยะเวลาประกันและหน่วยระยะเวลาประกัน");
    }
  };

  handleUploadContentMedia = (product_warrantee_id, files) => {
    Promise.all(
      files.map((e) => {
        return new Promise(async (resolve) => {
          if (e.isNewUpload) {
            const bodyFormData = new FormData();
            bodyFormData.set("product_warrantee_id", product_warrantee_id);
            bodyFormData.set("type", e.fieldName);
            bodyFormData.append("image", e);
            let res =
              await portalService.POST_PRODUCT_WARRANTEE_UPLOAD_IMAGE(
                bodyFormData,
              );
            if (res && res.status === 200) {
              resolve();
            }
          }
        });
      }),
    ).then(() => {
      toast.success("อัพเดจสำเร็จ");
      this.fetchData();
    });
  };

  handleCloseModal = () => {
    this.setState({
      renderModal: false,
    });
  };

  handleProductWarrantyRegis = (e) => {
    this.setState({
      renderModal: (
        <ProductWarrantyRegisterContainer
          data={e}
          onCancel={this.handleCloseModal}
          onRegistedSuccess={() => {
            this.handleCloseModal();
            this.setState({
              isLoading: true,
            });
            this.fetchData();
          }}
        />
      ),
    });
  };

  handleDeleteSlip = (index, value) => {
    AlertControl.show({
      title: "ลบรูปใบเสร็จ",
      description: "คุณต้องการลบรูปใบเสร็จนี้ใช่หรือไม่?",
      btnLabel2: "ยืนยัน",
      btnLabel1: "ยกเลิก",
      onEvent2: async () => {
        this.setState({ isBgLoading: true });
        let res = await portalService.PUT_PRODUCT_WARRANTEE_SLIP_IMG_DELETE(
          this.props.router.params.id,
          { slip_img_path: [value] },
        );
        if (res && res.status === 200) {
          this.setState({
            isLoading: true,
          });
          toast.success("ลบรูปใบเสร็จสำเร็จ");
          this.fetchData();
        } else {
          toast.error("ไม่สามารถลบรูปใบเสร็จได้ กรุณาลองใหม่อีกครั้ง");
        }
        this.setState({ isBgLoading: false });
      },
    });
  };

  handleClickBack = (e) => {
    this.props.router.navigate(-1);
  };

  render() {
    const { authenRedux } = this.props;
    const { isLoading, isBgLoading, data, renderModal, actionLogs } =
      this.state;
    const renderUnit = RENDER_UNIT(data?.warranty_unit);
    const renderExtensionUnit = RENDER_UNIT(data?.extension_unit);
    const renderStatus = RENDER_STATUS_PRODUCT_WARRANTY(data?.status);
    // const renderWarrantyStatus = RENDER_WARRANTY_STATUS(
    //   data?.status,
    //   CHECK_WARRANTY(
    //     data?.approved_warranty_date,
    //     data?.warranty_period,
    //     data?.warranty_unit,
    //     data?.extension_period,
    //     data?.extension_unit
    //   )
    // );
    const renderWarrantyStatus = RENDER_WARRANTY_STATUS(
      data?.warranty_status,
      CHECK_WARRANTY(
        data?.approved_warranty_date,
        data?.warranty_period,
        data?.warranty_unit,
        data?.extension_period,
        data?.extension_unit,
      ),
    );
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "product_warranty");
    return (
      <ProductWarranteeDetailContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        {isLoading ? (
          <Displays.Loading theme_standard_loading />
        ) : (
          <>
            <div className="info_timeline_row">
            <div className="block_section info_col">
              <div className="title">ข้อมูลการรับประกัน</div>
              <div className="body">
                <div className="value_item_wrap">
                  <Displays.LabelValue
                    label={"ชื่อสินค้า"}
                    value={`${data.description} ${
                      data.description_line_2 || ""
                    }`}
                  />
                </div>
                <div className="value_item_wrap">
                  <Displays.LabelValue
                    label={"หมายเลขสินค้า"}
                    value={data.item_no}
                  />
                </div>
                <div className="value_item_wrap">
                  <Displays.LabelValue
                    label={"ระยะเวลาการรับประกัน"}
                    value={
                      !data.warranty_period
                        ? "-"
                        : `${data.warranty_period} ${renderUnit.labelTH}`
                    }
                  />
                </div>
                <div className="value_item_wrap">
                  <Displays.LabelValue
                    label={"ขยายระยะเวลาการรับประกัน"}
                    value={
                      !data.extension_period
                        ? "-"
                        : `${data.extension_period} ${renderExtensionUnit.labelTH}`
                    }
                  />
                </div>
                <div className="value_item_wrap">
                  <Displays.LabelValue
                    label={"เงื่อนไข"}
                    value={data.warranty_description_th}
                  />
                </div>
                <div className="value_item_wrap">
                  <Displays.LabelValue
                    label={"Serial no"}
                    value={data.serial_no}
                  />
                </div>
                <div className="value_item_wrap">
                  <Displays.LabelValue
                    label={"Invoice no"}
                    value={data.invoice_no}
                  />
                </div>
                <div className="value_item_wrap">
                  <Displays.LabelValue
                    label={"Invoice type"}
                    value={data.invoice_type}
                  />
                </div>
                <div className="value_item_wrap">
                  <Displays.LabelValue
                    label={"Invoice date"}
                    value={
                      data.invoice_date &&
                      `${moment(data.invoice_date).format("DD/MM/YYYY")}`
                    }
                  />
                </div>
                <div className="value_item_wrap">
                  <Displays.LabelValue
                    label={"Registed at"}
                    value={
                      !data.registed_at
                        ? "-"
                        : `${moment(data.registed_at).format("DD/MM/YYYY")}`
                    }
                  />
                </div>
                <div className="value_item_wrap">
                  <Displays.LabelValue
                    label={"Warranty Start"}
                    value={
                      !data.approved_warranty_date
                        ? "-"
                        : `${moment(data.approved_warranty_date).format(
                            "DD/MM/YYYY",
                          )}`
                    }
                  />
                </div>
                <div className="value_item_wrap">
                  <Displays.LabelValue
                    label={"Warranty expired"}
                    value={
                      !data.approved_warranty_date && data.status !== "3"
                        ? "-"
                        : CAL_WARRANTY_EXPIRE(
                            data.approved_warranty_date,
                            data.warranty_period,
                            data.warranty_unit,
                            data.extension_period,
                            data.extension_unit,
                          ).format("DD/MM/YYYY")
                    }
                  />
                </div>
                <div className="value_item_wrap">
                  <Displays.LabelValue
                    label={"Dealer code"}
                    value={data.dealer_code}
                  />
                </div>
                <div className="value_item_wrap">
                  <Displays.LabelValue
                    label={"Dealer name"}
                    value={data.dealer_name}
                  />
                </div>
                <div className="value_item_wrap">
                  <Displays.LabelValue
                    label={"Store name"}
                    value={
                      <div className="edit_row">
                        {data.store_name_by_admin || data.store_name || "-"}
                        <ProductWarrantyStoreNameWidget
                          {...data}
                          productWarrantyID={this.props.router.params.id}
                          onUpdateSuccess={() => {
                            this.setState({
                              isLoading: true,
                            });
                            this.fetchData();
                          }}
                        />
                      </div>
                    }
                  />
                </div>
                <div className="value_item_wrap">
                  <Displays.LabelValue
                    label={"สถานะ"}
                    value={
                      <Displays.StatusLabel
                        bg={renderStatus?.bg}
                        label={renderStatus?.label}
                      />
                    }
                  />
                </div>
                <div className="value_item_wrap">
                  <Displays.LabelValue
                    label={"ประกัน"}
                    value={
                      <div className="edit_row">
                        <Displays.StatusLabel
                          bg={renderWarrantyStatus?.bg}
                          label={renderWarrantyStatus?.label}
                        />
                        <ProductWarrantyStatusWidget
                          {...data}
                          productWarrantyID={this.props.router.params.id}
                          onUpdateSuccess={() => {
                            this.setState({
                              isLoading: true,
                            });
                            this.fetchData();
                          }}
                        />
                      </div>
                    }
                  />
                </div>
              </div>
            </div>
            <div className="block_section timeline_col">
              <div className="title">ประวัติการดำเนินการ (Timeline)</div>
              <div className="body">
                <div className="timeline_wrap">
                  {actionLogs && actionLogs.length > 0 ? (
                    actionLogs.map((log, i) => {
                      const action = this.renderActionLabel(log.action_type);
                      const actor = this.renderActorLabel(log.actor_type);
                      return (
                        <div className="timeline_item" key={log._id || i}>
                          <span
                            className="timeline_dot"
                            style={{ background: action.color }}
                          />
                          <div className="timeline_body">
                            <div
                              className="timeline_action"
                              style={{ color: action.color }}
                            >
                              {action.label}
                              {actor ? ` ${actor}` : ""}
                            </div>
                            <div className="timeline_meta">
                              {moment(log.created_at).format(
                                "DD/MM/YYYY HH:mm",
                              )}
                            </div>
                            {log.note && (
                              <div className="timeline_note">
                                หมายเหตุ: {log.note}
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="timeline_empty">ยังไม่มีประวัติการดำเนินการ</div>
                  )}
                </div>
              </div>
            </div>
            </div>
            {data.status === "1" && permission?.is_update && (
              <div className="btn_regis_wrap">
                <Buttons.BgIconPrefix
                  label="เพิ่มการลงทะเบียน"
                  icon={<MdAdd size={18} />}
                  onClick={() => this.handleProductWarrantyRegis(data)}
                />
              </div>
            )}
            {data.status !== "1" ? (
              <>
                <div className="block_section">
                  <div className="title">ลงทะเบียนโดย</div>
                  <div className="body">
                    <div className="value_item_wrap">
                      <Displays.LabelValue
                        label={"ชื่อ"}
                        value={`${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
                          ...permission,
                          inputString: data.first_name,
                        })} ${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
                          ...permission,
                          inputString: data.last_name,
                        })}`}
                      />
                    </div>
                    <div className="value_item_wrap">
                      <Displays.LabelValue
                        label={"เบอร์โทร"}
                        value={RENDER_CHARACTER_REPLACE_BY_PERMISSION({
                          ...permission,
                          inputString: data.phone_number,
                          type: "phone",
                        })}
                      />
                    </div>

                    <div className="value_item_wrap">
                      <Displays.LabelValue
                        label={"อีเมล"}
                        value={
                          !data.email
                            ? "-"
                            : RENDER_CHARACTER_REPLACE_BY_PERMISSION({
                                ...permission,
                                inputString: data.email,
                              })
                        }
                      />
                    </div>
                    <div className="value_item_wrap">
                      <Displays.LabelValue
                        label={"เพศ"}
                        value={RENDER_GENDER_TYPE(data.gender)?.labelTh}
                      />
                    </div>
                    <div className="value_item_wrap">
                      <Displays.LabelValue
                        label={"จังหวัด"}
                        value={data.province}
                      />
                    </div>
                    <div className="value_item_wrap">
                      <Displays.LabelValue
                        label={"วันเกิด"}
                        value={momentTZ(data.birthday)
                          .tz("Asia/Bangkok")
                          .format("DD/MM/YYYY")}
                      />
                    </div>
                  </div>
                </div>
                {data.slip_img && (
                  <div className="block_section">
                    <div className="title">รูปใบเสร็จ</div>
                    <div className="body">
                      <div className="slip_list">
                        {data.slip_img.map((e, i) => (
                          <div className="slip_item" key={i}>
                            <Zoom>
                              <img
                                className="slip_img"
                                alt="slip"
                                src={IMG_PATH + e}
                              />
                            </Zoom>
                            <button
                              className="btn_delete_slip"
                              onClick={() => {
                                this.handleDeleteSlip(i, e);
                              }}
                            >
                              <MdDelete color="red" size={"26"} />
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
                <Forms.ProductWarrantyForm
                  initialValues={data}
                  isFormDisabled={
                    !permission || !permission?.is_update ? true : false
                  }
                  onSubmit={this.handleSubmit}
                  handleClickBack={this.handleClickBack}
                />
                {data.status !== "1" &&
                  data.status !== "2" &&
                  data.status !== "5" && (
                    <Displays.LabelValue
                      label={"สถานะ"}
                      value={RENDER_STATUS_PRODUCT_WARRANTY(data?.status).label}
                    />
                  )}
              </>
            ) : (
              <div className="button_wrap">
                <Buttons.BgStandard
                  theme_gray
                  label="Back"
                  onClick={this.handleClickBack}
                />
              </div>
            )}
          </>
        )}
        <Modals.BodyEmpty
          isShowModal={renderModal}
          onCloseModal={this.handleCloseModal}
        >
          {renderModal}
        </Modals.BodyEmpty>
      </ProductWarranteeDetailContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(ProductWarranteeDetailContainer));
